import { ALL_REGIONS } from '../../primitives/scope/region-param';

/** The query parameter that marks the Overview root as All regions, on purpose. */
export const OVERVIEW_SCOPE_PARAM = 'scope';

/**
 * Where "All regions" goes on Overview. The bare `/admin/overview` is the
 * landing page, where a viewer without read:all is sent to their own region;
 * the explicit address is how choosing All regions sticks.
 */
export const OVERVIEW_ALL_REGIONS_HREF = `/admin/overview?${OVERVIEW_SCOPE_PARAM}=${ALL_REGIONS}`;
